import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";

interface IndexProviderProps {
  children: ReactNode;
  callback?: () => void;
}

interface IndexContextValue {
  modalConfig: ModalConfig;
  setModalConfig: Dispatch<SetStateAction<ModalConfig>>;
  callback?: () => void;
}

const IndexContext = createContext<IndexContextValue | undefined>(undefined);

const IndexProvider: React.FC<IndexProviderProps> = ({
  children,
  callback,
}) => {
  const [modalConfig, setModalConfig] = useState<ModalConfig>(
    createModalConfig()
  );

  return (
    <IndexContext.Provider value={{ modalConfig, setModalConfig, callback }}>
      {children}
    </IndexContext.Provider>
  );
};

const useIndexContext = (): IndexContextValue => {
  const context = useContext(IndexContext);
  if (!context) {
    throw new Error("useIndexContext must be used within an IndexProvider");
  }
  return context;
};

export { IndexProvider, useIndexContext };
